import React from 'react';
import { Grid } from '@mui/material';
import PsychologyIcon from '@mui/icons-material/Psychology';
import { Section, InfoField } from '../ViewPatientDialog.utils';

export default function LifePathTab({ patient }) {
  const fiche = patient?.fiche_patient;

  return (
    <Section icon={<PsychologyIcon />} title="Histoire et parcours de vie" subtitle="Éléments biographiques et personnels">
      <Grid container spacing={2}>
        <InfoField label="Enfance, famille et naissance" value={fiche?.enfance_famille_naissance} fullWidth multiline />
        <InfoField label="Vie de couple et famille" value={fiche?.vie_couple_famille} fullWidth multiline />
        <InfoField label="Vie professionnelle" value={fiche?.vie_professionnelle} fullWidth multiline />
        <InfoField label="Vie aujourd'hui" value={fiche?.vie_aujourd_hui} fullWidth multiline />
        <InfoField label="Résumé du chemin de vie" value={fiche?.resume_chemin_de_vie} fullWidth multiline />
        <InfoField label="Parcours général" value={fiche?.parcours_general} fullWidth multiline />
      </Grid>
    </Section>
  );
}